import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { BasePerson, Document, CompanyData } from "@parts";
import { FormControl } from 'react-bootstrap'
import { lang } from '@config'
import { setStateRegistry } from "@parts/company-data/actions";

import SetFiscal from './is-fiscal';

//const branchPage = lang.pages.branches;

class BranchInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  UNSAFE_componentWillMount() { }
  render() {
    const isCompany = ![0, 3].includes(this.props.type)
    return (
      <div className="row">
        <div className="col-md-6 col-lg-6">
          <div className="js-basic-information">
            {isCompany ? (
              <React.Fragment>
                <div className="my-2">
                  <Document />
                </div>
                <div className="my-2">
                  <BasePerson
                    nameLabel="Razão Social"
                    namePlaceholder="Informe a razão Social da Empresa"
                    emailLabel="Email Empresarial"
                    emailPlaceholder="Ex: juliasilva@gmail.com"
                    phoneNumberLabel="Telefone empresarial"
                    phoneNumberPlaceholder="Ex: (91) 98183-8119"
                    context="Filial"
                  />
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="my-2">
                  <BasePerson
                    nameLabel="Seu nome"
                    namePlaceholder="ex: Julia Silva"
                    emailLabel="Seu email"
                    emailPlaceholder="Ex: juliasilva@gmail.com"
                    phoneNumberLabel="Telefone para contato"
                    phoneNumberPlaceholder="Ex: (91) 98183-8119"
                    context="Filial"
                  />
                </div>
                <div className="my-2">
                  <Document />
                </div>
              </React.Fragment>
            )}
          </div>
        </div>

        {![0,3].includes(this.props.type) ? (
          <div className="col-md-6 col-sm-6">
            {" "}
            <CompanyData ieCnae crt im />
          </div>
        ) : null}
      </div>
    );
  }
  componentWillUnmount() { }
}

const mapStateToProps = state => ({
  type: state.personType,
  stateRegistry: state.stateRegistry
});
const mapDispatchToProps = dispatch => bindActionCreators({ setStateRegistry }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(BranchInfo);



// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/branch-info.jsx